import { getSettingSelfServeRetailerTaxonomy } from "@faire/help-center-utils/settings/getSettingSelfServeRetailerTaxonomy";
export var HowToFindBrandsThatHaveInsiderFreeShippingIA = function HowToFindBrandsThatHaveInsiderFreeShippingIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return HOW_TO_FIND_BRANDS_WITH_INSIDER_FREE_SHIPPING(strictLocalize);
    },
    getDescription: function getDescription() {
      return [TO_FIND_BRANDS_AND_PRODUCTS_OFFERING_INSIDER_FREE_SHIPPING(strictLocalize)];
    }
  };
};
var HOW_TO_FIND_BRANDS_WITH_INSIDER_FREE_SHIPPING = function HOW_TO_FIND_BRANDS_WITH_INSIDER_FREE_SHIPPING(strictLocalize) {
  return getSettingSelfServeRetailerTaxonomy() ? strictLocalize({
    id: "PYlSze",
    defaultMessage: [{
      "type": 0,
      "value": "Find brands with Insider free shipping"
    }]
  }) : strictLocalize({
    id: "B8cwFF",
    defaultMessage: [{
      "type": 0,
      "value": "How can I find brands with Insider free shipping?"
    }]
  });
};
var TO_FIND_BRANDS_AND_PRODUCTS_OFFERING_INSIDER_FREE_SHIPPING = function TO_FIND_BRANDS_AND_PRODUCTS_OFFERING_INSIDER_FREE_SHIPPING(strictLocalize) {
  return strictLocalize({
    id: "HHlKBq",
    defaultMessage: [{
      "type": 0,
      "value": "To find brands and products offering Insider free shipping, just keep an eye out for the \"Insider free shipping\" blue key symbol while browsing the site. When you see a product or brand that has this symbol, you’ll automatically get Insider free shipping when you check out with that brand. Moreover, you can customise your shopping experience to only show products with Insider free shipping. To do this, find the Insider filter at the top of the category you’re browsing and click on it."
    }]
  });
};